var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16663 30.5002C1.16663 31.6052 1.60561 32.665 2.38701 33.4464C3.16842 34.2278 4.22822 34.6668 5.33329 34.6668H30.3333V1.3335H5.33329C4.22822 1.3335 3.16842 1.77248 2.38701 2.55388C1.60561 3.33529 1.16663 4.39509 1.16663 5.50016V30.5002ZM1.16663 30.5002C1.16663 29.3951 1.60561 28.3353 2.38701 27.5539C3.16842 26.7725 4.22822 26.3335 5.33329 26.3335H30.3333M9.49996 9.66683H22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.62d0e855373c7e500a7272db8de827cb.svg";
export { ForwardRef as ReactComponent };